import * as Yup from 'yup';

const MFASchema = () =>
  Yup.object({
    pinCode: Yup.string().length(6).required(),
  });

export type MFASchemaType = Yup.InferType<ReturnType<typeof MFASchema>>;

export default MFASchema;
